
import * as appsettings from "../appsettings";
import * as form from "../form";
import * as main from "../main";


let LABEL_YES = "";
let LABEL_NO = "";
let LABEL_DELETE = "";

function setCheckBoxes(): void {

    const dropDownList = $("#SelectGroup").data("kendoDropDownList");
    if (dropDownList != null && dropDownList != undefined) {

        const listItems = dropDownList.dataSource.view();
        const selectedItem = listItems[dropDownList.select()];

        $("input[name='SelectGroupID']").val(selectedItem.GroupID);

        const cbL = $("#OccupancyProposalLCD").data("kendoCheckBox");
        if (cbL != null && cbL != undefined) {
            /*cbL.element[0].checked = selectedItem.LCD_Enabled;*/
            cbL.check(selectedItem.LCD_Enabled);
        }

        const cbP = $("#OccupancyProposalPager").data("kendoCheckBox");
        if (cbP != null && cbP != undefined) {
            /*cbP.element[0].checked = selectedItem.Pager_Enabled;*/
            cbP.check(selectedItem.Pager_Enabled);
        }

        const cbPEU = $("#OccupancyProposalEachUser").data("kendoCheckBox");
        if (cbPEU != null && cbPEU != undefined) {
            /*cbPEU.element[0].checked = selectedItem.EachUser_Enabled;*/
            cbPEU.check(selectedItem.EachUser_Enabled);
        }

        const cbPOM = $("#OccupancyProposalForCustomOccupancyMin").data("kendoCheckBox");
        if (cbPOM != null && cbPOM != undefined) {
            /*cbPOM.element[0].checked = selectedItem.OccupancyProposalForCustomOccupancyMin_Enabled;*/
            cbPOM.check(selectedItem.OccupancyProposalForCustomOccupancyMin_Enabled);
        }
    }

    loadOtherViews();
}


function loadOtherViews(): void {

    const dropDownList = $("#SelectGroup").data("kendoDropDownList");
    if (dropDownList != null && dropDownList != undefined) {

        const listItems = dropDownList.dataSource.view();
        const selectedItem = listItems[dropDownList.select()];

        //--- NoOccupancyProposalMessageTable ---//
        if (selectedItem.LCD_Enabled ||
            selectedItem.Pager_Enabled ||
            selectedItem.EachUser_Enabled) {
            $("#divOccupancyProposalTable").load(appsettings.getUrl("OccupancyProposal/GetTable?groupId=" + selectedItem.GroupID));
            main.setHideDiv("divOccupancyProposalTable", true);
        } else {
            main.setHideDiv("divOccupancyProposalTable", false);
        }

        //--- Counters ---//
        $("#divOccupancyProposalCounters").load(appsettings.getUrl("OccupancyProposal/GetCounters?groupId=" + selectedItem.GroupID));

        //--- LastMsg ---//
        if (selectedItem.ShowLastMsg) {
            $("#divOccupancyProposalLastMessage").load(appsettings.getUrl("OccupancyProposal/GetLastMessage?groupId=" + selectedItem.GroupID));
        }
        main.setHideDiv("divOccupancyProposalLastMessage", selectedItem.ShowLastMsg);
    }
}

function noOccupancyProposalListReloadListView(groupId: number): void {

    // Get Data
    $.ajax({
        type: "GET",
        url: appsettings.getUrl("OccupancyProposal/LoadNoOccupancyProposalList") + "?groupId=" + groupId,
        data: { groupId: groupId },
        success: function (responseData) {
            if (responseData != undefined) {
                var listView = $("#NoProposalForMessagesWith_CplSelected").data("kendoListBox");
                listView.dataSource.data(responseData.items);
            }
        }
    });
}

function noOccupancyProposalListRemoveMessage(groupId: number): void {

    const messagesArr: number[] = [];

    const listView = $("#NoProposalForMessagesWith_CplSelected").data("kendoListBox");

    if (listView != undefined) {

        const items = listView.select();
        const allitems = listView.items();

        for (let cnt = 0; cnt < items.length; cnt++) {
            const idx = allitems.index(items[cnt]);
            const dataItem = listView.dataSource.view()[idx];
            messagesArr[cnt] = parseInt(dataItem.Value);
        }
    }

    const list = messagesArr.slice();

    // Post Data
    $.ajax({
        type: "POST",
        url: appsettings.getUrl("OccupancyProposal/RemoveMessagesFromGroup"),
        data: { list: kendo.stringify(list), groupId: groupId },
        success: function (responseData: responseModel|undefined|null) {

            // refresh list
            noOccupancyProposalListReloadListView(groupId);

            if (responseData != undefined && responseData != null) {

                if (responseData.Succesfully == false) {
                    main.openActionsDialog(' ', responseData.Message,
                        [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                } else {

                    // disable delete button
                    document.getElementById("NoOccupancyProposalList_delete-button").setAttribute("disabled", "disabled");
                }
            }

        }
    });
}


export function initialize(labelYes: string, labelNo: string, labelDelete: string): void {
    LABEL_YES = labelYes;
    LABEL_NO = labelNo;
    LABEL_DELETE = labelDelete;
}

export function onGroupsLoaded(): void {
    setCheckBoxes();
}

export function onGroupChanged(): void {
    setCheckBoxes();
}

export function reloadDDL(): void {
    const dropDownList = $("#SelectGroup").data("kendoDropDownList");
    if (dropDownList != null && dropDownList != undefined) {
        $.ajax({
            type: "GET",
            url: appsettings.getUrl("OccupancyProposal/GetGroups"),
            success: function (responseData) {
                if (responseData != undefined) {
                    dropDownList.dataSource.data(responseData);
                }
            }
        });
    }
}

export function tbNoProposalForMessagesInputChanged(): void {
    const btnAdd = document.getElementById("NoOccupancyProposalList_add-button");
    btnAdd.removeAttribute("disabled");
}

export function noOccupancyProposalListEnableDeleteButton(): void {
    const btnDelete = document.getElementById("NoOccupancyProposalList_delete-button");
    btnDelete.removeAttribute("disabled");
}

export function noOccupancyProposalListAddClicked(groupId: number): void {

    const inp = document.getElementById("TBNoProposalForMessages");

    if (inp != undefined) {

        // Post Data
        $.ajax({
            type: "POST",
            url: appsettings.getUrl("OccupancyProposal/Add_NoProposalForMessageWith_ToGroup"),
            data: { label: (inp as HTMLInputElement).value, groupId: groupId },
            success: function (responseData) {
                // refresh list
                noOccupancyProposalListReloadListView(groupId);

                if (responseData != undefined && responseData != null) {
                    if (responseData.Succesfully == false) {
                        main.openActionsDialog(' ', responseData.Message,
                            [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                    } else {
                        // clear add field
                        (document.getElementById("TBNoProposalForMessages") as HTMLInputElement).value = "";

                        // disable Add button
                        (document.getElementById("NoOccupancyProposalList_add-button") as HTMLButtonElement).setAttribute("disabled", "disabled");
                    }
                }
            }
        });
    }
}

export function noOccupancyProposalListDeleteClicked(groupId: number, questionMessage: string, yesText: string, noText: string): void {
    main.openActionsDialog(' ', questionMessage,
        [{ text: yesText, action: function () { noOccupancyProposalListRemoveMessage(groupId); main.closePopup(); } },
        { text: noText, action: function () { main.closePopup(); } }]);
}

export function updateCountersClicked(groupId: number): void {

    // Serialize the occupancyProposalCounters

    const post_data: OccupancyProposalCountersSaveVM = {
        GroupID: groupId,
        CounterValues: []
    };

    const cntrVals = $("input[id^='TB_']");

    for (let i = 0; i < cntrVals.length; i++) {

        const idsplit = cntrVals[i].id.split('_');

        // create new counter object
        const occupancyCounter: OccupancyCounter = {
            UserID: Number(idsplit[1]),
            ServiceFunctionID: Number(idsplit[2]),
            Value: Number((cntrVals[i] as HTMLInputElement).value.replace(",", ".")),
            Show: true
        };

        post_data.CounterValues.push(occupancyCounter);
    }

    // Post Data
    $.ajax({
        type: "POST",
        url: appsettings.getUrl("OccupancyProposal/SaveCounters"),
        data: JSON.stringify(post_data),
        contentType: "application/json",

        success: function (responseData: responseModel|undefined|null) {
            // Show request result
            form.showServerResponse("form_OccupancyProposalCounter", responseData, function () { });
        }
    });
}


export function lastMessageResetClicked(msgGroupId: number, groupId: number) {

    // Post Data
    $.ajax({
        type: "POST",
        url: appsettings.getUrl("OccupancyProposal/ResetCounters"),
        data: { msgGroupId: msgGroupId },

        success: function (responseData) {

            // refresh counters view
            $("#divOccupancyProposalCounters").load(appsettings.getUrl("OccupancyProposal/GetCounters?groupId=" + groupId));

            // Disable reset button
            main.setHideKendoUIFormItem3("LastMessage_reset-button", false);

            // Show request result
            form.showServerResponse("form_OccupancyProposalMsg", responseData, function () { });
        }
    });
}
